import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MatProgressSpinner, ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {NgIf} from '@angular/common';

@Component({
    selector     : 'smm-loader',
    templateUrl  : './smm.loader.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatProgressSpinner,
        NgIf
    ]
})
export class SmmLoaderComponent
{
    @Input() strokeWidth: number = 1;
    @Input() diameter: number = 74;
    @Input() mode: ProgressSpinnerMode = 'indeterminate';
    @Input() progress: number = 0;
    @Input() text: string = 'Se încarcă datele ...';
}
